/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2022-01-20 14:50:31
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\trill\trill.js
 * @Description: 抖音渠道主模块
 */
angular
    .module('editingCenterTrillModule', [
        'editTrillLeftModule',
        'editTrillRouterModule',
        'editTrillToBeCompiledModule',
        'editTrillToBeCompiledNewsModule',
        'editTrillPendingModule',
        'editTrillSignedModule',
        'editTrillDraftBoxModule',
    ])
    .controller('EditingCenterTrillCtrl', [function() {}])
    .value('trillConst', {
        mediaType: 17, // 抖音渠道的medidType
        draftIdKey: 'DOUYINARTICLEID', // 稿件的主键ID
        // accountKey: 'douYinAccountId', // 账号的主键ID
        accountKey: 'accountId', // 账号的主键ID
        trench: 'Trill', // 用来区分渠道的标识，各种操作时需要的
        serviceidKey: 'mlf_douyin', // serviceid的区分
        closeListenKey: 'douyin', // 关闭编辑页用的
        // 抖音渠道常量（包括请求参数、完整渠道变量等常量）
        trial: {
            // 送审参数
            serviceid: 'mlf_douyinoper',
            methodname: 'trialDouYinArticle',
        },
        sign: {
            // 签发参数
            serviceid: 'mlf_douyinoper',
            methodname: 'publishDouYinArticle',
        },
        draftListQuery: {
            // 发稿单查询参数
            serviceid: 'mlf_appfgd',
            methodname: 'queryFgdByDouYinArticleId',
        },
        draftListDB: {
            // 待编发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'douyinDaiBianbatchUpdateFgdUsers',
        },
        draftListDS: {
            // 待审发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'douyinDaiShenbatchUpdateFgdUsers',
        },
        delete: {
            // 废稿参数
            serviceid: 'mlf_douyinoper',
            methodname: 'abolishDouYinArticles',
        },
        propagandaReview: {
            // 宣传部送审参数
            serviceid: 'mlf_douyinoper',
            methodname: 'trialByPropagandaDepartment',
        },
        rejection: {
            // 撤稿参数
            serviceid: 'mlf_douyinoper',
            methodname: 'withdrawDouYinArticles',
        },
        retraction: {
            // 取消签发参数
            serviceid: 'mlf_douyinoper',
            methodname: 'cancelDouYinArticle',
        }
    });
